export const CURRENT_CONFIG = {

  // license (verifica lato H5 via platformVerifyLicense)
  appId: '188308',
  appKey: 'ced1171aa47d87dba196b7a2ce9248c',
  appLicense: 'kqzt6tqq7CXHSJZZcmdRbigGsjy53vI82E0qxBm90GW8btFYoNy0xOpxwInUBiCwI3r7qf41IFqzUgTZQZ3vGk4Q95R+4pHwh0ObpM6iXC5QSeEsGajvYEZdA6iTB+W3RosVAB9M4yWMAdvZcsm2++D3z82Xw6PCSRPUNVcE0DE=',

  // http: stesso dominio del frontend (routing per path su Traefik -> nessun CORS)
  baseURL: 'https://dji.tokiostudio.it/',
  websocketURL: 'wss://dji.tokiostudio.it/api/v1/ws',

  // livestreaming (non usato ora)
  rtmpURL: '',
  gbServerIp: '',
  gbServerPort: '',
  gbServerId: '',
  gbAgentId: '',
  gbPassword: '',
  gbAgentPort: '',
  gbAgentChannel: '',
  rtspUserName: '',
  rtspPassword: '',
  rtspPort: '8554',
  agoraAPPID: '',
  agoraToken: '',
  agoraChannel: '',

  // map: chiave AMap/Gaode (opzionale; la mappa web AMap e' centrata sulla Cina,
  // per l'Italia i tiles possono essere poveri ma NON impatta Pilot ne' le API)
  amapKey: '',

}
